module.exports = __webpack_public_path__ + "static/media/1.87069073.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/unused icon/1.svg
// module id = 415
// module chunks = 14